import AdBlockDetector from 'shared/ad_block_detector';
import { getPlatform, LocationMediator } from 'shared/vidio_helpers';
import AhoyEvent from 'shared/ahoy_event';

const AhoyPageviewEvent = {
  getEventTime: function () {
    return Math.floor(Date.now() / 1000);
  },

  sendEvent: function() {
    var eventProperties = {
      app_name     : 'vidio',
      page         : LocationMediator.href(),
      referrer     : document.referrer,
      platform     : getPlatform(),
      has_adblocker: AdBlockDetector.hasAdBlocker(),
      event_time   : this.getEventTime()
    };

    AhoyEvent.send('PAGEVIEW', eventProperties);
  },

  sendEventFromPlayer: function(pathUrl){
    var eventProperties = {
      app_name : 'vidio',
      page     : pathUrl,
      referrer : LocationMediator.href(),
      platform : getPlatform(),
      event_time   : this.getEventTime()
    };

    AhoyEvent.send('PAGEVIEW', eventProperties);
  }
};

export default AhoyPageviewEvent;
